// extracted by mini-css-extract-plugin
export default {"avatarWrapper":"avatar__avatarWrapper"};